<template>
  <EditarBase
    :itemAtual="itemAtual"
    :recursoInicial="recursoInicial"
    nomePlural="SupportSubjects"
    nomeSingular="SupportSubject"
    :camposObrigatorios="[{ campo: 'nome', label: 'Nome' }]"
    @recurso="recurso = $event"
    @submitSuccess="emitSubmitSuccess"
    @submitError="emitSubmitError"
    @closeModalEdit="closeModalEdit"
  >
    <v-col v-if="recurso.id" cols="12">
      <v-row>
        <v-col cols="12" md="8">
          <v-text-field
            v-model.trim="recurso.nome"
            :label="$t('Nome')"
            name="nome"
            maxlength="200"
            obrigatorio
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          />
        </v-col>

        <v-col cols="12" md="2">
          <v-text-field
            v-model.number="recurso.ordem"
            :label="$t('Ordem')"
            name="ordem"
            type="number"
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          />
        </v-col>

        <v-col cols="12" md="2">
          <v-checkbox v-model="recurso.ativo" :label="$t('Ativo')" />
        </v-col>
      </v-row>
    </v-col>
  </EditarBase>
</template>

<script>
import EditarBase from "@/components/base/Crud/EditarBase";
import { createSupportSubjectDataService } from "@/services/support/SupportSubjectDataService";

export default {
  name: "EditarSupportSubject",
  components: { EditarBase },
  props: {
    itemAtual: { type: Object, required: false, default: null },
    recursoInicial: { type: Object, required: false, default: null },
  },
  data() {
    const supportScope =
      this.$route?.meta?.supportScope || this.$route?.query?.escopo || null;
    return {
      DataService: createSupportSubjectDataService(supportScope),
      recurso: {
        id: null,
        nome: "",
        ordem: 0,
        ativo: true,
      },
    };
  },
  methods: {
    emitSubmitSuccess(recursoAtualizado = this.recurso) {
      this.$emit("submitSuccess", recursoAtualizado);
    },
    emitSubmitError() {
      this.$emit("submitError");
    },
    closeModalEdit() {
      this.$emit("closeModalEdit");
    },
  },
};
</script>
